import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  noRecordsWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "24px 0px",
    maxWidth: "352px",
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      color: colors.grey,
      marginBottom: 0
    }
  }
}));

export default styles;
